import React, { useState, useEffect } from "react";
// Importing scrollbar library
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import Select from "react-select";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../component/modal-popup/customeModal";

// Importing Redux
import { useSelector, useDispatch } from "react-redux";
import { masterActivityData } from "../../redux/actions/onboarding";
import { getDepartment } from "../../redux/actions/department";
import { getUser } from "../../redux/actions/user";

function OnboardingSlide6({
  page,
  formik,
  FieldArray,
  FormikProvider,
  Form,
  addRemoveElement,
  setActivityData,
  errorForSlide6,
  setErrorForSlide6,
}) {
  const dispatch = useDispatch();
  const { masterActivity } = useSelector((state) => state.onboarding);
  const { slider_3_Data } = useSelector((state) => state.onboarding);
  const [userOptions, setUserOptions] = useState([]);
  const [teamsOptions, setTeamsOptions] = useState([]);
  const [userData, setUserData] = useState([]);

  const getMasterActivity = () => {
    const request = {
      business_id: slider_3_Data.business_type.value,
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Something went wrong. Please try again later."
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(masterActivityData(request));
  };

  const getDepartmentData = () => {
    dispatch(
      getDepartment((res) => {
        if (res.status === 0) {
          swal({
            content: (
              <CustomeModal type="error" title="Error!" content={res.message} />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        } else {
          const teamsArr = [];
          res.data?.data.map((item) => {
            teamsArr.push({ value: item.id, label: item.name });
          });
          setTeamsOptions(teamsArr);
        }
      })
    );
  };

  const getUserData = () => {
    const request = {
      onSuccess: (res) => {
        if (res?.length > 0) {
          const userArr = [];
          setUserData(res);
          res.map((item) => {
            userArr.push({
              value: item.id,
              label: item.first_name + " " + item.last_name,
            });
          });
          setUserOptions(userArr);
        }
      },
      onError: (error) => {
        swal({
          content: (
            <CustomeModal type="error" title="Error!" content={error.message} />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(getUser(request));
  };

  useEffect(() => {
    if (page === 6) {
      getMasterActivity();
      getDepartmentData();
      getUserData();
    }
  }, []);

  useEffect(() => {
    if (errorForSlide6) {
      setTimeout(() => {
        setErrorForSlide6(!errorForSlide6);
      }, 2000);
    }
  }, [errorForSlide6]);

  return (
    <div
      className="px-16 pt-16 space-y-4 h-full"
      style={{ maxHeight: "calc(100% - 80px)" }}
    >
      <div className="grid grid-cols-2 gap-4 h-[95%] 2xl:h-[90%]">
        <div className="space-y-4">
          <div className="block w-[60px]">
            <img
              alt="Logo"
              src={require("../../assets/img/ShiproneLogo.png")}
            />
          </div>
          <div>
            <p className="font-bold text-2xl leading-9 tracking-tight">
              Lets Create
            </p>
            <p className="font-bold text-2xl leading-9 tracking-tight">
              Some <span className="text-[#2f80ed]">To Dos</span>
            </p>
          </div>
          <div className="w-3/4">
            <p className="text-base font-medium leading-6 tracking-tight text-[#1E293B]">
              We have some To Do suggestions for you based on organisations
              similar to yours.
            </p>
          </div>
          <div className="w-3/4">
            <p className="text-base font-medium leading-6 tracking-tight text-[#1E293B]">
              Just select the to dos that you perform and assign your created
              teams and users.
            </p>
          </div>
          <div>
            <a
              href="https://meetings.hubspot.com/abidwai/shiperone-workflow-demo"
              target="__blank"
              className="text-[#2f80ed] border-b border-[#2f80ed] font-semibold text-sm leading-10 tracking-tight py-2"
            >
              Schedule Personal Onboarding
            </a>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="max-h-[384px] bg-[#F2F8FE] rounded-[20px] text-center px-10 py-4 overflow-y-auto">
            {masterActivity.map((element, index) => (
              <div
                key={index}
                title={element.name}
                className={`border h-10 p-2 text-sm font-semibold leading-8 text-center text-[#1E293B] rounded-md cursor-pointer truncate overflow-hidden my-1 ${
                  formik.values.toDoData.some(
                    (item) => item.activity_id?.name === element.name
                  )
                    ? "bg-[#2f80ed] hover:bg-[#136be0] text-white"
                    : "border-slate-300 hover:border-slate-400 bg-white"
                }`}
                onClick={(e) => addRemoveElement(element)}
              >
                {element.name}
              </div>
            ))}
          </div>
          <div className="space-y-1">
            {errorForSlide6 && (
              <div className="bg-[#D313131A]/10 px-3 py-2 rounded-2xl -mt-8 space-x-2 flex items-center">
                <span className="fa-solid fa-circle-exclamation fill-current text-base text-[#D31313]"></span>
                <span className="text-[13px] text[#383C43] font-medium leading-4 tracking-tight">
                  Please select and configure at least one to do
                </span>
              </div>
            )}

            <div className="w-[260px] h-[384px] bg-[#F2F8FE] rounded-[20px] text-center px-10 py-4 overflow-y-auto">
              <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate>
                  <FieldArray
                    name="toDoData"
                    render={(arrayHelpers) => (
                      <div>
                        {formik.values.toDoData.length > 0 &&
                          formik.values.toDoData.map((item, index) => (
                            <div className="mt-2">
                              <div
                                key={index}
                                className={`border h-10 p-2 text-sm font-semibold leading-8 text-center rounded-md cursor-pointer truncate overflow-hidden my-1 bg-[#2f80ed] hover:bg-[#136be0] text-white`}
                              >
                                {item.activity_id?.name}
                              </div>
                              <Select
                                menuPortalTarget={document.body}
                                className="unresetText text-left text-sm  mt-1 border-0 border-[#E5E7EB]"
                                name="TeamName"
                                options={teamsOptions}
                                value={teamsOptions.filter(
                                  (team) =>
                                    team.value ===
                                    formik.values.toDoData[index].team_name
                                )}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  placeholder: (base) => ({
                                    ...base,
                                    color: "#9B9B9B",
                                  }),
                                }}
                                placeholder="Select Team"
                                onChange={(teamName) => {
                                  formik.setFieldValue(
                                    `toDoData[${index}].team_name`,
                                    teamName.value
                                  );
                                  setActivityData((prev) => {
                                    return prev.map((to_do, i) => {
                                      if (i === index) {
                                        to_do.team_name = teamName.value;
                                      }
                                      return to_do;
                                    });
                                  });
                                }}
                              />
                              <Select
                                menuPortalTarget={document.body}
                                className="unresetText text-left text-sm border-0 border-[#E5E7EB]"
                                name="TeamName"
                                options={
                                  userOptions.filter((data) => {
                                    const user = userData.find(
                                      (user) => user?.id === data?.value
                                    );

                                    return user?.departments
                                      ? user?.departments.some(
                                          (item) =>
                                            item?.id ===
                                            formik.values.toDoData[index]
                                              ?.team_name
                                        )
                                      : false;
                                  }).length > 0
                                    ? userOptions.filter((data) => {
                                        const user = userData.find(
                                          (user) => user?.id === data?.value
                                        );
                                        return user?.departments.some(
                                          (item) =>
                                            item?.id ===
                                            formik.values.toDoData[index]
                                              ?.team_name
                                        );
                                      })
                                    : []
                                }
                                value={userOptions.filter(
                                  (team) =>
                                    team.value ===
                                    formik.values.toDoData[index].user_name
                                )}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  placeholder: (base) => ({
                                    ...base,
                                    color: "#9B9B9B",
                                  }),
                                }}
                                classNames={{
                                  control: (style) => {
                                    return `!border !shadow-sm ${
                                      style.isFocused
                                        ? "!border-[--bg-color-300]/50"
                                        : "!border-slate-200 hover:!border-gray-300"
                                    }`;
                                  },
                                  container: (style) => {
                                    return "!h-[37.5px] !font-inter !text-sm";
                                  },
                                  menuList: (style) => {
                                    return `!max-h-[200px]`;
                                  },
                                }}
                                placeholder="Select User"
                                onChange={(userName) => {
                                  formik.setFieldValue(
                                    `toDoData[${index}].user_name`,
                                    userName.value
                                  );
                                  setActivityData((prev) => {
                                    return prev.map((to_do, i) => {
                                      if (i === index) {
                                        to_do.user_name = userName.value;
                                      }
                                      return to_do;
                                    });
                                  });
                                }}
                              />
                            </div>
                          ))}
                      </div>
                    )}
                  />
                </Form>
              </FormikProvider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OnboardingSlide6;
